import { LayoutGraph, LayoutStageBase, Point } from '@yfiles/yfiles'

export class FlowEdgeThroughNodeStage extends LayoutStageBase {
  public applyLayoutImpl(graph: LayoutGraph): void {
    this.coreLayout?.applyLayout(graph)
    graph.nodes
      .filter((node) => node.inDegree > 0 && node.outDegree > 0)
      .forEach((node) => {
        const nodeLayout = node.layout
        node.inEdges.forEach((edge) => {
          edge.targetPortLocation = new Point(nodeLayout.centerX, edge.targetPortLocation.y)
        })
        node.outEdges.forEach((edge) => {
          edge.sourcePortLocation = new Point(nodeLayout.centerX, edge.sourcePortLocation.y)
        })
      })
  }
}
